import { render } from "./TheHeader.vue?vue&type=template&id=a739709e&scoped=true"
const script = {}

import "./TheHeader.vue?vue&type=style&index=0&id=a739709e&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\astac\\OneDrive\\Рабочий стол\\twodolist\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a739709e"]])

export default __exports__